<mojo-activity-recorder></mojo-activity-recorder>
<mojo-desktop-alert></mojo-desktop-alert>
<mojo-brand-css-loader brandLinkId="brand-style"></mojo-brand-css-loader>
<div class="main-container container">
  <router-outlet></router-outlet>
</div>
